import React from 'react';
import './Expertise.css';
import { FaEarListen, FaLink, FaLanguage } from "react-icons/fa6";

const Expertise = () => {
  return (
    <section className="expertise-section" id="expertise-section">
      <div className="expertise-container">
        <div className="expertise-label">Our Approach</div>
        <h2 className="expertise-title">
          How We Apply the <span className="highlight">"Emic" Principle</span>
        </h2>
        <p className="expertise-description">
          We apply an emic lens to every challenge by:
        </p>

        <div className="expertise-cards">
          <div className="expertise-card">
            <div className="card-icon"><FaLink /></div>
            <h3 className="card-title">Connecting</h3>
            <p className="card-description">
              We build authentic relationships with local communities and key partners.
            </p>
            <ul>
              <li>Cultural preference mapping</li>
              <li>Consumer journey analysis</li>
              <li>Social media sentiment research</li>
            </ul>
            {/* <a href="#" className="learn-more">
              Learn More →
            </a> */}
          </div>

          <div className="expertise-card">
            <div className="card-icon"><FaEarListen /></div>
            <h3 className="card-title">Listening</h3>
            <p className="card-description">
              We prioritize deep, qualitative research to understand motivations and behaviors.
            </p>
            <ul>
              <li>Real-time trend monitoring</li>
              <li>Predictive analytics</li>
              <li>Competitive intelligence</li>
            </ul>
            {/* <a href="#" className="learn-more">
              Learn More →
            </a> */}
          </div>

          <div className="expertise-card">
            <div className="card-icon"><FaLanguage /></div>
            <h3 className="card-title">Translating</h3>
            <p className="card-description">
              We bridge the cultural gap, ensuring your brand story resonates naturally in a new context.
            </p>
            <ul>
              <li>Expert translation</li>
              <li>Cultural adaptation</li>
              <li>Brand localization</li>
            </ul>
            {/* <a href="#" className="learn-more">
              Learn More →
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;